import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { GenericPagingVM, MessageVM } from '../../../models';
import { UserType } from '../../../models/UserType';

@Component({
  selector: 'account-messages',
  templateUrl: './messages.component.html'
})
export class MessagesComponent extends BaseComponent implements OnInit {

  model: GenericPagingVM = new GenericPagingVM();
  tokenCache: any = new Object();

  constructor(
    private route: ActivatedRoute,
    private accService: AccountService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.emitDisplayLoadingDialog(true);
    this.accService.getMessages(this.model)
      .subscribe(
        returnValue => {
          this.model = returnValue;
        },
        e => e,
        () => {
          this.emitDisplayLoadingDialog(false);
        }
      );
  }

  //onNext() {
  //  if (this.model.nextPagingToken != null) {

  //    this.model.items = [];  //clear current screen
  //    this.model.pageNo++;    //increment current page
  //    this.tokenCache[this.model.pageNo] = this.model.nextPagingToken;
  //    this.emitDisplayLoadingDialog(true);

  //    this.accService.getMessages(this.model)
  //      .subscribe(returnValue => {
  //        this.emitDisplayLoadingDialog(false);
  //        this.model.items = returnValue.items;
  //        this.model.nextPagingToken = returnValue.nextPagingToken;
  //        this.model.pageNo = returnValue.pageNo;
  //        this.model.pageSize = returnValue.pageSize;
  //        this.model.totalPages = returnValue.totalPages;
  //      });
  //  }
  //}

  //onPrevious() {
  //  if ((this.model.pageNo - 1) >= 1) {

  //    this.model.items = [];                                              //clear current screen
  //    this.model.pageNo--;                                                //decrement current page
  //    this.model.nextPagingToken = this.tokenCache[this.model.pageNo];;   //set token to get previous results
  //    this.emitDisplayLoadingDialog(true);

  //    this.accService.getMessages(this.model)
  //      .subscribe(returnValue => {
  //        this.emitDisplayLoadingDialog(false);
  //        this.model.items = returnValue.items;
  //        this.model.nextPagingToken = returnValue.nextPagingToken;
  //        this.model.pageNo = returnValue.pageNo;
  //        this.model.pageSize = returnValue.pageSize;
  //        this.model.totalPages = returnValue.totalPages;
  //      });
  //  }
  //}

  otherPartyName(item: MessageVM): String {
    if (item.from.userType != UserType.client) {
      return item.from.name;
    }
    else {
      return item.to.name;
    }
  }

  otherPartyImage(item: MessageVM): String {
    if (item.from.userType != UserType.client) {
      return item.from.profileImage;
    }
    else {
      return item.to.profileImage;
    }
  }

}
